import { CartItem } from './cart-item.model';
import { UserResponse } from '../login/response/user.response.model';
import { GetProductsRequest } from '../request/product.request';

export class CartTax {
    userName: string;
    cmsDealerNumber: string;
    productForm: GetProductsRequest;
    cart: CartItem[];

    constructor(user: UserResponse = new UserResponse(), cart: CartItem[] = [], productForm?: GetProductsRequest) {
        this.userName = user.userName;
        this.cmsDealerNumber = user.cmsDealerNumber;
        this.productForm = productForm;
        this.cart = cart;
    }
}
